
import { Component, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import DialogImgLarge from '@/components/ImgLarge/index.vue';
import dialogDeviceDetail from './components/DeviceDetail.vue';
import dialogDeviceRecord from './components/DeviceRecord.vue';
import searchForm from "./components/DeviceSearch.vue";
import { getAuthCus, setAuthCusDetail, deleteAuthCusDetail, batchQrCode, productList } from '@/api/device';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';

@Component({
  name: 'DeviceToCustomer',
  components: {
    DialogImgLarge,
    dialogDeviceDetail,
    dialogDeviceRecord,
    searchForm
  }
})
export default class extends Vue {
  private tableData = [];
  private selectedbox = [];
  private checkAll = false;
  private isIndeterminate: any = null;
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private dialogDeviceRecordVisible = false;
  private dialogDeviceDetailVisible = false;
  private dialogDeviceEditVisible = false;
  private rowData = {};
  private fromDeviceEdit: any = {
    warranty_period: '',
    warranty_start_time: '',
    manufacturer_warranty_state: '',
    company_id: '',
    user_id: '',
    auth_id: '',
    device_id: '',
    manufacturer_phone: ''
  }
  private deviceSearch: any = {}
  private isShowDeviceHistry=false;

  private deviceData:any={}
  created() {
    this.isShowDeviceHistry = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.DeviceHistry);

    if (this.$route.query && this.$route.query.onlyId) {
      this.deviceSearch.customer = this.$route.query;
      this.selectCustomer(this.deviceSearch.customer);
    }
    this.getList();
  }

  // 传参进入的customer 和选择的 customer 有差异
  selectCustomer(val:any) {
    let customerId = '';
    if (parseInt(val.customer_type) === 1) {
      customerId = val.company_id;
    } else {
      customerId = 'p' + val.user_id;
    }
    this.deviceSearch.customer = customerId;
    this.deviceData.customer = {
      id: customerId,
      name: val.name
    }
  }

  deviceSearchHandle(val: any) {
    this.deviceSearch = val;
    if (val) {
      this.getList()
    }
  }
  private getList() {
    this.selectedbox = [];
    this.isIndeterminate = false;
    let pamars:any = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      ...this.deviceSearch
    };
    getAuthCus(pamars).then(res => {
      if (res.data) {
        this.tableData = res.data.list;
        this.pagination.total = res.data.count;
      } else {
        this.pagination.total = 0;
        this.tableData = [];
      }
    }).catch(err => {
      this.tableData = [];
      this.pagination.total = 0;
      let msg = err.msg;
    });
  }
  handleSelectionChange(value: any) {
    let checkedCount = value.length;
    this.checkAll = checkedCount === this.tableData.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.tableData.length;
  }

  // 全选
  handleCheckAllChange(val: boolean) {
    this.selectedbox = val ? this.tableData : [];
    this.isIndeterminate = false;
  }

  handlePageSizeChange(val:number) {
    this.pagination.currentPage = 1;
    this.pagination.pageSize = val;
    this.getList();
  }
  handleCurrentChange(val:number) {
    this.pagination.currentPage = val;
    this.getList();
  }

  detailsHandle(val: any) {
    this.dialogDeviceDetailVisible = true;
    this.rowData = val;
  }
  closeDetailHandle(value: any) {
    this.dialogDeviceDetailVisible = value;
  }

  recordHandle(val:any) {
    this.dialogDeviceRecordVisible = true;
    this.rowData = val;
  }
  closeRecordHandle(value: boolean) {
    this.dialogDeviceRecordVisible = value;
  }

  // 编辑
  private originalChange(val:any) {
    if (val) {
      if (!this.fromDeviceEdit.manufacturer_phone) {
        this.showErrorMsg('请在编辑设备中先填写设备的厂商信息,再开启原厂保修');
        this.$set(this.fromDeviceEdit, 'manufacturer_warranty_state', false);
      }
    }
  }
  private editHandle(val:any) {
    this.fromDeviceEdit = {
      warranty_period: val.warranty_period,
      warranty_start_time: val.warranty_start_time,
      manufacturer_warranty_state: parseInt(val.manufacturer_warranty_state) === 1,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_id: UserModule.getUserId,
      auth_id: val.auth_id,
      device_id: val.device_id,
      company_name: val.company_name,
      manufacturer_phone: val.manufacturer_phone
    };
    this.dialogDeviceEditVisible = true;
  }

  private editSave() {
    let pamars:any = {
      warranty_start_time: this.fromDeviceEdit.warranty_start_time,
      warranty_period: this.fromDeviceEdit.warranty_period,
      manufacturer_warranty_state: this.fromDeviceEdit.manufacturer_warranty_state ? 1 : 0,
      company_id: this.fromDeviceEdit.company_id,
      user_id: this.fromDeviceEdit.user_id,
      auth_id: this.fromDeviceEdit.auth_id,
      device_id: this.fromDeviceEdit.device_id
    };
    setAuthCusDetail(pamars).then(res => {
      this.dialogDeviceEditVisible = false;
      this.getList();
    }).catch(err => {
      let msg = err.msg;
    });
  }
  // 取消授权
  private cancelHandle(val:any) {
    let _this = this;
    this.$confirm('确认取消授权吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        let params:any = {
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          user_id: UserModule.getUserId,
          id: val.auth_id,
          device_id: val.device_id
        };
        deleteAuthCusDetail(params).then((res:any) => {
          this.showSecussMsg(res.msg);
          this.getList();
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
      })
      .catch(() => {});
  }
  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  // 导出二维码
  private improtOutQr() {
    if (!this.selectedbox || this.selectedbox.length < 1) {
      this.$notify.warning({
        title: '提示',
        message: '请选择设备'
      });
      return;
    }
    let id = '';
    for (var item of this.selectedbox) {
      id = id + (item as any).id + ',';
    }
    let params:any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    params.id = id.substring(0, id.length - 1);
    batchQrCode(params).then(res => {
    }).catch(err => {
      if (!err.msg) {
        let blob = new Blob([err]);
        let fileName = new Date().getTime() + '.pdf';
        if ('download' in document.createElement('a')) {
          // 非IE下载
          let elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
        // IE10+下载
          // navigator.msSaveBlob(blob, fileName);
        }
        this.$message.success('下载文件成功');
      } else {
        this.$message.error(err.msg);
      }
    });
  }

  private dropdownHandle(name: any) {
    let funcname: any = this.$options.methods;
    funcname[name].bind(this)();
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
